export const contractTypes = [
	{ label: "Master Service Agreement (MSA)", value: "master_service" },
	{ label: "Non-Disclosure Agreement (NDA)", value: "non_disclosure" },
	{ label: "Data Processing Agreement (DPA)", value: "data_processing" },
	{ label: "Statement of Work (SOW)", value: "statement_of_work" },
	{ label: "Others", value: "unknown" },
];
